import React from "react";
import { TaskStatus } from "shared/services";
import styles from "../styles.module.scss";

interface ProgressBarProps {
	value: number;
	status: TaskStatus;
}

const progressClassByStatus: Record<TaskStatus, string> = {
	pending: styles.progressPending,
	processing: styles.progressProcessing,
	completed: styles.progressCompleted,
	failed: styles.progressFailed,
	paused: styles.progressPaused,
	cancelled: styles.progressFailed,
};

export const ProgressBar: React.FC<ProgressBarProps> = ({ value, status }) => {
	const safeValue = Math.min(100, Math.max(0, Math.round(value)));

	return (
		<div
			className={styles.progressTrack}
			role="progressbar"
			aria-valuemin={0}
			aria-valuemax={100}
			aria-valuenow={safeValue}
		>
			<div
				className={`${styles.progressFill} ${progressClassByStatus[status]}`}
				style={{ width: `${safeValue}%` }}
			/>
		</div>
	);
};
